var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",class:{ box: _vm.mask && !_vm.paused }},[_c('MarqueeText',{attrs:{"duration":_vm.duration,"repeat":_vm.paused ? 1 : 2,"paused":_vm.paused}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }